import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { LIST_HISTORY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { ListHistoryDataActionTypes } from './types';
import modelsApi from 'src/utils/api/modelsApi';

export const loadListHistory =
  (
    id: string,
  ): ThunkAction<Promise<void>, State, null, ListHistoryDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: LIST_HISTORY + REQUEST });
    try {
      const payload = await modelsApi.loadListHistory(id);
      dispatch({ type: LIST_HISTORY + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: LIST_HISTORY + FAILURE, error });
    }
  };
